import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    itemPerPage: 5,
    customerAccessCode: null,
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.customerAccessCode = null;
    },
    setItemPerPage: (state, action) => {
      state.itemPerPage = action.payload;
    },
    setCustomerAccessCode: (state, action) => {
      state.customerAccessCode = action.payload;
    },
  },
});

export const { login, logout, setItemPerPage, setCustomerAccessCode } = userSlice.actions;

// export const selectUser = (state) => state.user.user;

export default userSlice.reducer;
